import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import MultipleChoice from './MultipleChoice'
import FillInTheBlank from './FillInTheBlank'
import SentenceClick from './SentenceClick'

import style from './style.css'

function isMcItem (item) {
  return item.questionType === 'MC'
}
function curCardToMultipleChoiceConfig (item) {
  return {
    question: {
      prompt: item.questionText,
      isComplete: item.completed,
      choices: item.choices.map((choice, index) => ({
        value: index,
        label: choice,
        isAnswered: item.answered.includes(index),
        isCorrect: item.correctAnswerIndex === index,
        isRemoved: item.hinted.includes(index)
      }))
    }
  }
}

function isFitbItem (item) {
  return item.questionType === 'FB'
}
function curCardToFillInTheBlankConfig (item) {
  const isAnswered = !_.isEmpty(item.userAnswer)
  let isCorrect
  if (isAnswered) {
    isCorrect = _.some(item.answers, (answer) => {
      return item.userAnswer.toLowerCase().replace(/\s/g, '') === answer.toLowerCase().replace(/\s/g, '')
    })
  }

  return {
    question: {
      prompt: item.questionText,
      isComplete: item.completed,
      isAnswered,
      isCorrect,
      hintConfig: item.hinted.length
        ? item.hinted[item.hinted.length - 1]
        : {
            letters: {},
            wordsLength: []
          }
    }
  }
}

function isScItem (item) {
  return item.questionType === 'SC'
}

function curCardToSentenceClickConfig (item) {
  return {
    question: {
      prompt: item.questionText,
      isComplete: item.completed,
      choices: item.choices.map((choice, index) => ({
        value: index,
        label: choice,
        isAnswered: item.answered.includes(index),
        isCorrect: item.correctAnswerIndex === index,
        isRemoved: item.hinted.includes(index)
      }))
    }
  }
}

export default function Question (props) {
  const { curCard, onAnswer, onSubmitFitb } = props

  let moduleConfig
  let moduleToRender
  if (isMcItem(curCard)) {
    moduleConfig = curCardToMultipleChoiceConfig(curCard)
    moduleToRender = (
      <MultipleChoice
        question={moduleConfig.question}
        onAnswer={onAnswer}
      />
    )
  } else if (isFitbItem(curCard)) {
    moduleConfig = curCardToFillInTheBlankConfig(curCard)
    moduleToRender = (
      <FillInTheBlank
        question={moduleConfig.question}
        onAnswer={onAnswer}
        onSubmit={onSubmitFitb}
      />
    )
  } else if (isScItem(curCard)) {
    moduleConfig = curCardToSentenceClickConfig(curCard)
    moduleToRender = (
      <SentenceClick
        question={moduleConfig.question}
        onAnswer={onAnswer}
      />
    )
  }

  useEffect(() => {
    if(document.querySelector('[data-test-id="activityQuestion"] img')) {
      document.querySelector('[data-test-id="activityQuestion"] img').style["maxWidth"] = "100%";
      document.querySelector('[data-test-id="activityQuestion"] img').style["maxHeight"] = "100%";
    }
  });

  const containerStyle = props.legacyEbook ? style.ebbokLegacyStyle : style.container
  let splitSmallStyle = ''
  if ((props.splitPane && (props.splitPaneWidth === '50%')) ||
    (props.splitPane && (window.innerWidth - props.splitPaneWidth) <= 768)) {
    splitSmallStyle = style.splitContent
  }
  return (
    <div
      data-test-id="question"
      className={classnames(containerStyle, splitSmallStyle)}
    >
      {moduleToRender}
    </div>
  )
}

Question.propTypes = {
  curCard: PropTypes.object.isRequired,
  onAnswer: PropTypes.func.isRequired,
  onSubmitFitb: PropTypes.func, // special to FitB, allows submitting answer on Enter
  hint: PropTypes.object,
  legacyEbook: PropTypes.bool,
  splitPane: PropTypes.bool,
  splitPaneWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}
